import { createApp } from 'vue'
import App from './App.vue'
import './assets/colors.css'
import './assets/tailwind.css'
import './assets/style.css'

createApp(App).mount('#app')
